<template>
    <div>
        <svg class="card-arrow" viewBox="0 0 24 24" width="16" height="16">
            <path fill="currentColor" d="M8.59 16.58L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.42z" />
        </svg>
    </div>
</template>